// Branch related endpoints
export const branchEndpoints = (builder) => ({
  // Branch CRUD operations
  getBranches: builder.query({
    query: (args = {}) => {
      const {
        pageNumber = 1,
        pageSize = 10,
        searchTerm,
        searchValue,
      } = args;

      const params = {
        pageNumber,
        pageSize,
      };

      // Add searchTerm and searchValue only if they are defined and not null
      if (searchTerm !== null && searchTerm !== undefined) {
        params.searchTerm = searchTerm;
      }
      if (searchValue !== null && searchValue !== undefined) {
        params.searchValue = searchValue;
      }

      return {
        url: '/common/branch-list',
        method: 'GET',
        params,
      };
    },
    providesTags: ['Branch'],
  }),

  getBranchById: builder.query({
    query: (id) => ({
      url: `/common/get-BranchById/${id}`,
      method: 'GET',
    }),
    providesTags: (result, error, id) => [{ type: 'Branch', id }],
  }),

  saveBranch: builder.mutation({
    query: (data) => ({
      url: '/common/save-branch',
      method: 'POST',
      body: data,
    }),
    invalidatesTags: ['Branch'],
  }),

  updateBranch: builder.mutation({
    query: ({ data }) => ({
      url: `/common/save-branch`,
      method: 'POST',
      body: data,
    }),
    invalidatesTags: (result, error, { id }) => [
      { type: 'Branch', id },
      'Branch'
    ],
  }),

  deleteBranch: builder.mutation({
    query: (id) => ({
      url: `/common/delete-branch/${id}`,
      method: 'DELETE',
    }),
    invalidatesTags: ['Branch'],
  }),

  bulkDeleteBranch: builder.mutation({
    query: (body) => ({
      url: "/common/bulk-delete-branch",
      method: "DELETE",
      body,
    }),
  }),

});
